<div *ngIf="tasks.length" [@fade]="'in'" [class.minimized]="minimize" class="queue_block">
    <div (click)="minimize = !minimize" *ngIf="!minimize" class="tray_button">
        <div class="tray"></div>
    </div>
    <div *ngIf="minimize"
         [class.blue]="fileQueueService.loadedCount() === tasks.length"
         [class.orange]="fileQueueService.loadedCount() !== tasks.length && !fileQueueService.errorQueue()"
         [class.red]="fileQueueService.errorQueue()"
         class="arrow">
    </div>
    <div class="queue_list">
        <div (click)="hideFileQueue(false)"
             *ngIf="minimize"
             [@fade]="'in'" class="queue_row minimized">
        </div>

        <div *ngIf="!minimize" [@listAnimation]="tasks.length" class="queues">
            <div *ngFor="let item of tasks" class="queue_row">
                <div [routerLink]="['/account', 'doc', 'file', item.target_key, item.version_key]" class="file_sub"
                     title="Нажмите, чтобы открыть эту версию файла">
                    <span class="file_name">{{ item.target.name }}</span>
                </div>
                <div>
                    <div class="progress_bar progress_bar_2px">
                        <div [class.success]="item.status === 'ok'" [ngStyle]="{width: loadMonitoring(item)}"></div>
                    </div>
                    <span class="file_status">
                        <small class="{{statusLoadColor(item)}}">
                            <b>{{ statusLoad(item) }}</b>
                        </small>
                        <small>
                            <b>{{ item.date_finish | date:'HH:mm dd.MM.yyyy' }}</b>
                        </small>
                    </span>
                </div>
            </div>
            <!-- TODO доработать пагинацию
            <div *ngIf="source_data.length > limit" class="queue_row" style="cursor: pointer; text-align: center">
                <span (click)="limit = limit + 10; paginate();"><b>Загрузить ещё</b></span>
            </div>
            -->
        </div>

    </div>
</div>
